<span class="badge badge-secondary">
    <i class="fas fa-gift"></i> Bonificação/Amostra
</span>